import { PatientContext } from "@/context/PatientContext";
import { useContext } from "react";

export const usePatientContext = () => {
    const context = useContext(PatientContext);
    if (!context) {
      throw new Error("usePatientContext must be used within a PatientProvider");
    }
    return context;
  };